// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"dfc4b20a","164":"7fa3073c","254":"82f5660c","301":"a918e78b","444":"60165507","453":"22cf9193","721":"e4d42ff2"}[chunkId] + ".chunk.js";
};